import { blackBase, contrast, whiteBase } from '@mentimeter/ragnar-colors';

export const getContrastingTextColor = (color: string) => {
  const contrastToWhite = contrast(color, whiteBase);
  return contrastToWhite > 4.5 ? whiteBase : blackBase;
};
